import { ZDate } from '../../../shared/zDate';
export class Role {
  _id?: number;
  name?: string;
  permission?: string;
  
  createdBy?: {
    _id:number,
    name?:string
  };
  createdDate?:number;
  createdDateX?:ZDate;
  updatedBy?: {
    _id:number,
    name?:string
  };
  updatedDate?:number;
  updatedDateX?:ZDate;
  deleted?: number;
  deletedBy?: {
    _id:number,
    name?:string
  };
  deletedDate?:number;
  deletedDateX?:ZDate;
}



// WEBPACK FOOTER //
// ./src/app/module/role/shared/role.ts